import { useState } from 'react';
import { Link } from 'react-router-dom';
import s from '../../styles/components/general/MobileNav.module.css';
import site from '../../data/master.json';

export default function MobileNav({ links }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button className={s.trigger} onClick={() => setOpen(!open)}>
        <span className={`${s.bar} ${open ? s.barTopOpen : ''}`} />
        <span className={`${s.bar} ${open ? s.barMidOpen : ''}`} />
        <span className={`${s.bar} ${open ? s.barBotOpen : ''}`} />
      </button>

      <div className={`${s.overlay} ${open ? s.overlayOpen : ''}`} onClick={() => setOpen(false)} />

      <div className={`${s.panel} ${open ? s.panelOpen : ''}`}>
        <nav className={s.nav}>
          {links.map((link) => (
            <Link
              key={link.label}
              to={link.path}
              className={s.link}
              onClick={() => setOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </>
  );
}